import { ActionTree } from 'vuex'
import { RootState } from '../../types'
import { SceneState } from './types'

export const actions: ActionTree<SceneState, RootState> = {
  async sync({ commit }, state: SceneState) {
    commit('syncState', state)
  },
}
